export default function getValue(value, postfix = '') {
  if (value === 0) return `0${postfix}`
  if (!value) return '—'
  return `${value}${postfix}`
}
